import {
  type ButtonClick,
  type InputFill,
  TrackingCategory,
  type TrackingContextValue,
  buttonClick
} from '@ps/web-shared-analytics';
import type { Optional } from 'utility-types';

import { GADimension } from '@swf/core/enums';

import { inputFocused } from './components';
import { GAEvent, memoize } from './utils';

export const searchFocused = (tracking: TrackingContextValue, fieldName: string) =>
  inputFocused(
    { ...tracking, category: TrackingCategory.Casino },
    { fieldName, fieldType: 'text' }
  );

export const searchFilled = memoize(
  (context: TrackingContextValue, data: Optional<InputFill, 'isAutoFilled'>) =>
    GAEvent({ action: 'Input Filled', label: data.fieldName }, context, {
      [GADimension.InputValue]: data.strInput
    }),
  '2.fieldContent'
);

export const searchClicked = (
  context: TrackingContextValue,
  { search, ...data }: ButtonClick & { search: string }
) => {
  GAEvent({ action: 'Button Pressed', label: data.buttonName }, context, {
    [GADimension.InputValue]: search
  });

  buttonClick(data, context);
};
